import { Component, OnDestroy, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SECTION_TITLES, DEFAULT_TITLE } from '@common/constants/section-titles.constants';
import { ISectionConst } from '@common/interfaces/titles.interface';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Utils } from '@common/utils/utils';
import { isPlatformBrowser } from '@angular/common';
import { LoadingService } from '@services/loading/loading.service';
import { FAKE_LOAD_MS } from '@common/constants/business.constants';

@Component({
  selector: 'app-base-form-layout',
  templateUrl: './base-form-layout.component.html',
  styleUrls: ['./base-form-layout.component.scss'],
})
export class BaseFormLayoutComponent implements OnInit, OnDestroy {
  currentPage: string;
  sectionConst: ISectionConst;
  showCollapse: boolean;
  collapseType: string;
  collapseTitle: string;
  private routerSubscription: Subscription;

  constructor(
    private router: Router,
    private utils: Utils,
    private loading: LoadingService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.sectionConst = DEFAULT_TITLE;
    this.showCollapse = false;
  }

  public ngOnInit() {
    this.setRouterPipe();
  }

  public setRouterPipe() {
    this.routerSubscription = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      this.currentPage = (event.urlAfterRedirects.split('?')[0]).substring(1);
      this.sectionConst = SECTION_TITLES[this.currentPage];
      this.collapseType = this.sectionConst?.collapseType;
      this.showCollapse = this.sectionConst?.hasCollapse;
      this.collapseTitle = this.sectionConst?.collapseTitle;
      this.fakeLoad();
      if (isPlatformBrowser(this.platformId)) { this.utils.scrollToId('baseFormContentSection'); }
    });
  }

  public ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  private fakeLoad() {
    this.loading.showLoading();
    setTimeout(() => this.loading.hideLoading(), FAKE_LOAD_MS);
  }

}
